import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { getCurrentUser } from 'aws-amplify/auth';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';

// Check if running in local development mode (no AWS required)
const LOCAL_MODE = process.env.REACT_APP_LOCAL_MODE === 'true';

// Configure Amplify only if not in local mode
if (!LOCAL_MODE && process.env.REACT_APP_COGNITO_USER_POOL_ID) {
  try {
    Amplify.configure({
      Auth: {
        Cognito: {
          region: process.env.REACT_APP_AWS_REGION,
          userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
          userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
        },
      },
    });
  } catch (error) {
    console.error('Failed to configure Amplify:', error);
  }
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      if (LOCAL_MODE) {
        // In local mode, auto-authenticate after brief delay
        setTimeout(() => {
          setIsAuthenticated(true);
          setLoading(false);
        }, 500);
      } else if (!process.env.REACT_APP_COGNITO_USER_POOL_ID) {
        // No Cognito config, go to local mode
        setIsAuthenticated(true);
        setLoading(false);
      } else {
        await getCurrentUser();
        setIsAuthenticated(true);
        setLoading(false);
      }
    } catch (error) {
      console.log('Not authenticated, showing login');
      setIsAuthenticated(false);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-purple-600 to-pink-600">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
          <p className="text-white text-lg">Loading Vedus Journey...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login onLoginSuccess={() => setIsAuthenticated(true)} isLocalMode={LOCAL_MODE} />} />
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Dashboard onLogout={() => setIsAuthenticated(false)} isLocalMode={LOCAL_MODE} />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={isAuthenticated ? <Navigate to="/dashboard" /> : <Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}

export default App;
